var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewBackArrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2083 12.5176H5.41775L11.4629 6.75741C11.7792 6.45578 11.7915 5.95466 11.4898 5.63799C11.1882 5.32211 10.6875 5.30905 10.3704 5.61107L3.4651 12.1918C3.16506 12.4918 3 12.8889 3 13.3092C3 13.7296 3.16506 14.1258 3.47896 14.4405L10.3704 21.0074C10.5236 21.1535 10.7203 21.2259 10.9167 21.2259C11.1257 21.2259 11.3343 21.1436 11.4898 20.9805C11.7915 20.6638 11.7792 20.1631 11.4629 19.8611L5.39044 14.1009H21.2083C21.6453 14.1009 22 13.7462 22 13.3092C22 12.8722 21.6453 12.5176 21.2083 12.5176Z",
    fill: "#F4D56E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBackArrowIcon);
export default __webpack_public_path__ + "static/media/new_back_arrow_icon.3614161b6bf293fb706988d7eb72b534.svg";
export { ForwardRef as ReactComponent };